import AgentDetailReports from './AgentDetailReports';

export default AgentDetailReports;
